
import { Badge } from '@/components/ui/badge';

interface StatusBadgeProps {
  status: 'live' | 'dev' | 'coming-soon';
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  switch (status) {
    case 'live':
      return (
        <Badge className="bg-[#D1FADF] text-[#027A48] hover:bg-[#D1FADF] border-0 rounded-full text-xs font-medium px-3 py-1">
          ✅ Live
        </Badge>
      );
    case 'dev':
      return (
        <Badge className="bg-[#E0F2FE] text-[#0369A1] hover:bg-[#E0F2FE] border-0 rounded-full text-xs font-medium px-3 py-1">
          ⚙️ In Dev
        </Badge>
      );
    case 'coming-soon':
      return (
        <Badge className="bg-[#E5E7EB] text-[#4B5563] hover:bg-[#E5E7EB] border-0 rounded-full text-xs font-medium px-3 py-1">
          ⏳ Coming Soon
        </Badge>
      );
    default:
      return null;
  }
};
